/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';
import { ILoyaltyBalanceCheckViewProps } from './loyalty-balance-check';
import { format } from '@msdyn365-commerce-modules/utilities';
import { useForm } from 'react-hook-form';
import { getLoyaltyCard_DLXAsync } from '../../actions/DataActionExtension.g';

const LoyaltyBalanceCheckView: React.FC<ILoyaltyBalanceCheckViewProps> = props => {
    // const user_card_number = (document.getElementById('loyalty-card-input') as HTMLInputElement).value;
    const [points, setPoints] = React.useState(-1);
    const [tier, setTier] = React.useState('');

    const { register, handleSubmit } = useForm();

    const _submit = async (data: { loyalty_card_number: string; email: string }) => {
        // Protip: Check if the loyalty card's associated email address matches with the input one for improved security
        // console.log(data.loyalty_card_number);
        // console.log(data.email);

        await getLoyaltyCard_DLXAsync({ callerContext: props.context.actionContext }, data.loyalty_card_number, data.email)
            .then(result => {
                const tmp_card = result[0];
                // @ts-ignore
                const firstLoyaltyGroup = tmp_card.LoyaltyGroups[0];
                const highestTierId = firstLoyaltyGroup.HighestActiveLoyaltyCardTier;
                // @ts-ignore
                const tierDetails = firstLoyaltyGroup.LoyaltyCardTiers.filter(tier => tier.RecordId === highestTierId)[0];
                if (tierDetails.TierId) {
                    setTier(tierDetails.TierId);
                }
                const tmp_points = tmp_card.RewardPoints ?? -1;
                setPoints(tmp_points[0].ActivePoints ?? -1);
                if (typeof window !== undefined) {
                    const points_div: HTMLDivElement = document.getElementById('points') as HTMLDivElement;
                    points_div.style.display = 'block';
                    const scrollIntoViewOptions: ScrollIntoViewOptions = { behavior: 'smooth' };
                    if (window.innerWidth < 992) {
                        (document.getElementById('text-p') as HTMLButtonElement).scrollIntoView(scrollIntoViewOptions);
                    }
                }
            })
            .catch(error => {
                setPoints(-1);
                if (typeof window !== undefined) {
                    const points_div: HTMLDivElement = document.getElementById('points') as HTMLDivElement;
                    points_div.style.display = 'block';
                    const scrollIntoViewOptions: ScrollIntoViewOptions = { behavior: 'smooth' };
                    if (window.innerWidth < 992) {
                        (document.getElementById('text-p') as HTMLButtonElement).scrollIntoView(scrollIntoViewOptions);
                    }
                }
                // console.log(error);
            });
    };

    return (
        <div className='loyalty-balance-check container'>
            <div className='row'>
                <div className='col-12'>
                    {props.config.headingText ? <h1>{props.config.headingText}</h1> : null}

                    {props.config.paragraphText ? (
                        <div
                            dangerouslySetInnerHTML={
                                // @ts-ignore
                                { __html: props.config.paragraphText }
                            }
                            id='text-p'
                            className='text-paragraph'
                        ></div>
                    ) : null}
                </div>
            </div>
            <div className='row'>
                <form onSubmit={handleSubmit(_submit)}>
                    <div className='col-lg-4 col-12 input-div'>
                        {props.config.loyaltyCardLabel ? <label htmlFor='loyalty-card-input'>{props.config.loyaltyCardLabel}</label> : null}
                        <input
                            id='loyalty-card-input'
                            name='loyalty_card_number'
                            type='text'
                            className='loyalty-card-input'
                            defaultValue={'V'}
                            ref={register({ required: true })}
                        />
                    </div>
                    <div className='col-lg-4 col-12 input-div'>
                        {props.config.emailLabel ? <label htmlFor='email-input'>{props.config.emailLabel}</label> : null}
                        <input
                            id='email-input'
                            name='email'
                            type='email'
                            className='email-input'
                            ref={register({ required: true, maxLength: 256, pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i })}
                        />
                    </div>
                    <div className='col-lg-3 col-12'>
                        <button type='submit' id='submit-btn' className='solid-button'>
                            {props.config.buttonLabel ? props.config.buttonLabel : null}
                        </button>
                    </div>
                </form>
            </div>
            <div className='row'>
                {props.resources.balanceCheckLabel && props.resources.balanceCheckError ? (
                    <div id='points' className='col-12 points'>
                        {points !== -1 && tier !== '' ? (
                            <p>{format(props.resources.balanceCheckLabel, points, tier)}</p>
                        ) : (
                            <p className='error'>{props.resources.balanceCheckError}</p>
                        )}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default LoyaltyBalanceCheckView;
